
import BuilderInputs  from './builder-inputs.vue'
export default {
  components: {
    BuilderInputs
  },
  props: {
    title: {type: String, required: true},
    tabs: {type: Array, default: undefined},
    opts: {type: [Array, Object], default: () => []},
    gap: {type: String, default: '2rem'},
    collapsible: {type: Boolean, default: false},
    style: {type: Object, default: () => {}}
  },
  emits: ['update'],
  data() {
    return {
      valid: true,
      current_tab: this.tabs && this.tabs[0]?.value,
      collapsed: false
    }
  },
  computed:{
    input_items(){
      return Array.isArray(this.opts) 
        ? this.opts
        : this.opts[this.current_tab]
    },
  }
}
